import { BfxBlotterOrdersContextMenuState } from "shared/cubiq-services";

export class BfxOrderDetailsContextMenuState extends BfxBlotterOrdersContextMenuState {
  public selectedDIEventIds: Array<any> = null;
  public requestRef: string = null;

  constructor() {
    super();
  }
}
